import { interpret } from '@fingermarkglobal/utilities';
import { createLoyaltyCreateRedemptionsMachine } from './machines/loyalty-create-redemptions';

const doLoyaltyCreateRedemptions = ({
  transition = null,
  token,
  transactionId,
  payload,
  promoId,
  redemptions,
}) => {
  const machine = createLoyaltyCreateRedemptionsMachine({
    token,
    transactionId,
    payload,
    promoId,
    redemptions,
  });

  const { instance: loyaltyCreateRedemptionsMachine } = interpret({
    name: 'loyaltyCreateRedemptionsMachine',
    machine,
    transition,
  });

  return { loyaltyCreateRedemptionsMachine };
};

export { doLoyaltyCreateRedemptions };
